import React, { useEffect } from "react";
// import storage from "../../Services/Storage";
import { useNavigate } from "react-router-dom";
import { useSalesReturnContext } from "../../context/SalesReturnContext";
// import storage from "../../Services/Storage";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import SalesReturnPrint from "./SalesReturnPrint";
import Loader from "../../Components/Loader";
import { Calendar } from "primereact/calendar";
import { MdRefresh } from "react-icons/md";
import storage from "../../Services/Storage";
import { useState } from "react";
import Axios from "../../api/Axios";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";

const Index = () => {
    // const auth = storage.getLocal("user");
    // const [selectedSalesRet, setSelectedSalesRet] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [selectedsalesInv, setSelectedsalesInv] = useState([]);
    const [surePopup, setSurePopup] = useState(false);
    const [selectedCn, setSelectedCn] = useState();
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(5);
    const auth = storage.getLocal("user");
    let EInv = false;
    //eslint-disable-next-line
  let print = true;
    const {
    // creditNotesColumn,
        getCreditNotes,
        // getDefaultCreData,
        creditNotesTable,
        // setCreditNotesTable,
        // allCreditNoteData,
        // setAllCreditNoteData,
        fromDate,
        toDate,
        // formattedSevenDaysAgo,
        // currentDate,
        setFromDate,
        setToDate,
        findDateSalesReturn,
        setViewSalesReturn,
        printInvoiceCall,
        invoiceDataLoad,
        setModalPopup,
        printInvoicePopUp
    } = useSalesReturnContext();

    const nav = useNavigate();

    const AddnewCreditNote = () => {
        nav(`/salesmanagement/salesreturn/details?mask_pro_id=${"null"}`);
    };

    // const downloadInvoice = () => {
    //     selectedSalesRet.forEach((item) => printInvoiceCall(item.MASK_INVH_ID));
    //     // const multiDownloadSalesReturn = selectedSalesRet.map(item => {
    //     //     printInvoiceCall(item.MASK_INVH_ID);
    //     // });
    //     //

    // };

    useEffect(() => {
    // calling function for Api
        setModalPopup(false);
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");

        getCreditNotes(fromDateRange, toDateRange);

        setViewSalesReturn(false);
        GetCompanyInfo();
    }, []);

    const renderAction = (rowdata) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View Product Details"
                    >
                        <button
                            className="grid-icon"
                            onClick={() => {
                                nav(
                                    `/salesmanagement/salesreturn/details?mask_salret_id=${encodeURIComponent(
                                        rowdata.MASK_INVH_ID
                                    )}&INVH=${encodeURIComponent(rowdata.INVH_DATE)}`
                                );
                            }}
                        >
                            <Fa.FaEye />
                        </button>
                    </div>
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Print"
                    >
                        {print === true && (
                            <button
                                className="grid-icon"
                                onClick={() => {
                                    printInvoiceCall([rowdata]);
                                }}
                            >
                                <Fa.FaPrint />
                            </button>
                        )}
                    </div>
                </div>
            </>
        );
    };
    const GetCompanyInfo = async () => {
        try {
            const url = `Invoice/GetCompanyInfo?CompId=${auth.CompId}`;
            const res = await Axios.get(url);
            console.log(res, "GetCompanyInfo");
            if (res.data.Status === "Success") {
                setCompanyInfo(res.data.Data);
            }
        } catch (ex) {
            console.log(ex);
        }
    };
    const EInvVisible = (rowData) => {
    // console.log(rowData, "rowData");
        if (auth.EInvApplicability === "Y") {
            console.log(rowData, "renderRetry");
            const parseDate = (str) => {
                if (str === undefined) {
                    return "";
                }
                const [day, month, year] = str.split("/");
                return new Date(`${year}-${month}-${day}`); // ISO format
            };
            let invdate = "";
            let EInvImpDate = "";
            if (
                rowData.INVH_DATE.toString() !== undefined ||
        rowData.INVH_DATE.toString() !== null ||
        rowData.INVH_DATE.toString() !== ""
            ) {
                invdate = parseDate(rowData.INVH_DATE.toString());
            }
            if (
                companyInfo[0]?.E_INVOICING_IMPLEMENTATION?.toString() !== undefined ||
        companyInfo[0]?.E_INVOICING_IMPLEMENTATION?.toString() !== null ||
        companyInfo[0]?.E_INVOICING_IMPLEMENTATION?.toString() !== ""
            ) {
                EInvImpDate = parseDate(
                    companyInfo[0]?.E_INVOICING_IMPLEMENTATION?.toString()
                );
            }
            if (
                EInvImpDate !== "" &&
        EInvImpDate !== undefined &&
        EInvImpDate !== null
            ) {
                if (invdate >= EInvImpDate) {
                    if (
                        rowData.MASK_IRN_NO !== "" &&
            rowData.MASK_IRN_NO !== null &&
            rowData.CUST_GSTN !== null &&
            rowData.CUST_GSTN !== "" &&
            (rowData.IRN_NO === null || rowData.IRN_NO === "")
                    ) {
                        EInv = true;
                        print = false;
                    } else {
                        EInv = false;
                        print = true;
                    }
                } else {
                    if (
                        rowData.CUST_GSTN !== null &&
            rowData.CUST_GSTN !== "" &&
            (rowData.IRN_NO === null || rowData.IRN_NO === "")
                    ) {
                        EInv = true;
                        print = false;
                    } else {
                        EInv = false;
                        print = true;
                    }
                }
            }
        }
    };
    const renderRetry = (rowData) => {
        EInvVisible(rowData);
        return (
            <>
                {EInv === true ? (
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Retry"
                    >
                        <a
                            onClick={() => {
                                setSurePopup(true);
                                setSelectedCn(rowData);
                            }}
                        >
              Retry <MdRefresh />
                        </a>
                        {/* <button
                    className="grid-icon"
                    
                >
                    <Fa.FaFileInvoice />
                </button> */}
                    </div>
                ) : (
                    ""
                )}
            </>
        );
    };
    const footerContent = (
        <div>
            <div className="text-end">
                <button
                    type="button"
                    className="btn btn-primary me-3"
                    onClick={() => RetyEinv()}
                >
          Yes <Fa.FaCheck />
                </button>
                <button
                    type="button"
                    className="btn btn-cancel-red"
                    onClick={() => {
                        setSurePopup(false);
                    }}
                >
          No <Fa.FaTimes />
                </button>
            </div>
        </div>
    );
    const RetyEinv = async () => {
        try {
            const api = "SalesReturn/RetyEinv";
            const obj = {
                EInvApplicability: auth.EInvApplicability,
                EInvIRPUserId: auth.EInvIRPUserId,
                EInvIRPUserPassword: auth.EInvIRPUserPassword,
                EInvGSTNO: auth.EInvGSTNO,
                strCNHDRId: selectedCn.MASK_INVH_ID,
                CUST_GSTN: selectedCn.CUST_GSTN,
            };
            const res = await Axios.post(api, JSON.stringify(obj));
            console.log(res, "RetryEInvAPI");
            if (res.data.Status === "Success") {
                toast.success(res.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                const fDate = new Date(fromDate);
                const fromDateRange = format(fDate, "dd/MM/yyyy");
                const tDate = new Date(toDate);
                const toDateRange = format(tDate, "dd/MM/yyyy");
                getCreditNotes(fromDateRange, toDateRange);
                setSurePopup(false);
            }
        } catch (ex) {
            toast.error(ex?.response?.data?.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
    };

    const printsalesInv = ()=>{
    

        printInvoiceCall(selectedsalesInv);
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <h3 className="py-2">Sales Return</h3>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="float-end mb-2">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={AddnewCreditNote}
                        >
              Add New
                        </button>
                    </div>
                </div>
            </div>
            <section className="sales-box">
                <form>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="float-end mt-4">
                                {/* <button
                                    type="button"
                                    title="Download"
                                    className="btn btn-outline-primary me-3"
                                    onClick={downloadInvoice}
                                    disabled={selectedSalesRet.length == 0 ? true : false}
                                >
                                    Download
                                </button> */}
                                <button
                                    type="button"
                                    className="btn btn-outline-primary me-3"
                                    onClick={(e) => findDateSalesReturn(e, fromDate, toDate)}
                                >
                  Get Credit Notes
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary "
                                    disabled={selectedsalesInv.length==0}
                                    onClick={printsalesInv}
                                >
                  Download <Fa.FaDownload className="ms-2" />
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
            <section className="mt-3">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="mb-3">All Records</h3>
                        <div className="DataTable pb-4">
                            {invoiceDataLoad ? (
                                <Loader />
                            ) : (
                                <DataTable
                                    value={creditNotesTable}
                                    // dataKey='MASK_PROD_ID'
                                    // selectionMode='single'
                                    // selection={selectedProductCode}
                                    // onSelectionChange={(e) => { productLotselect ? setSelectedLot(e.value) : setSelectedProductCode(e.value); }}
                                    paginator
                                    // showGridlines
                                    stripedRows
                                    filterDisplay="row"
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    scrollHeight="80vh"
                                    tableStyle={{ minWidth: "60rem" }}
                                    scrollable
                                    rows={rows}
                                    first={first}
                                    selectionPageOnly={true}
                                    onPage={(e) => {
                                        setFirst(e.first);
                                        setRows(e.rows);
                                        setSelectedsalesInv([]);
                                    }}
                                    globalFilterFields={["PROD_CODE", "DESCRIPTION"]}
                                    emptyMessage="No records found."
                                    selectionMode="checkbox"
                                    selection={selectedsalesInv}
                                    onSelectionChange={(e) => {
                                        setSelectedsalesInv(e.value);
                                    }}
                                >
                                    <Column
                                        selectionMode="multiple"
                                        headerStyle={{ width: "5rem" }}
                                        header="Select All"
                                    ></Column>
                                    <Column
                                        field={"INVH_NO"}
                                        header={"Credit Note Number"}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                        style={{ minWidth: "12rem" }}
                                    />
                                    <Column
                                        field={"INVH_DATE"}
                                        header={"Credit Note Date"}
                                        style={{ minWidth: "12rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    />
                                    <Column
                                        field={"CUST_NAME"}
                                        header={"Customer Name"}
                                        style={{ minWidth: "12rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    />
                                    <Column
                                        field={renderRetry}
                                        header="Retry E-Invoice"
                                        className="text-center"
                                    />
                                    <Column field={renderAction} header="Action" />
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            {printInvoicePopUp&&<SalesReturnPrint setSelectedsalesInv={setSelectedsalesInv}/>}
            <Dialog
                header="Confirmation"
                visible={surePopup}
                style={{ width: "50vw" }}
                // onHide={() => setSurePopup(false)}
                closable={false}
                resizable={false}
                draggable={false}
                footer={footerContent}
            >
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <p className="mb-0">
            E-Invoice will be generated. Do you want to proceed?
                    </p>
                </div>
            </Dialog>
        </div>
    );
};

export default Index;
